import React, { Component } from 'react';
import { Row, Col, Button } from 'reactstrap';
import Modal from 'react-modal';
import { Icon } from 'react-fa';

import { Profile } from './Profile';
import './SocialWall.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/smartadmin-production.min.css';
import '../assets/css/smartadmin-production-plugins.min.css';

class SocialWall extends Component {
	state = { profileModal: false }

  toggleModal() {
    this.setState({ profileModal: !this.state.profileModal });
    this.props.onModalToggle();
  }

  render() {
  return (
    <div id="content" className="socialWall">
      <Modal
        isOpen={this.state.profileModal}
        style={modalStyle}
        contentLabel=""
      >
        
          <Profile />
          <div className="close-div">
            <Button color="secondary" className="close-button" onClick={this.toggleModal.bind(this)}>
              <Icon name="times" size="2x" />
            </Button>
          </div>
        
      </Modal>
      <section id="widget-grid" className="">
        <h1><strong>Social Wall</strong></h1>
        <Row>
          <Col xs="12" sm="6" lg="4">
            <div className="panel panel-default">
              <div className="panel-body status">
                <div className="who clearfix">
                  <img src={require('../../assets/images/avatars/yadho.png')} alt="img" className="online" onClick={this.toggleModal.bind(this)} />
                  <span className="name" onClick={this.toggleModal.bind(this)}><b>Ya Doh</b> invested <strong>$5,000</strong> in fundrise</span>
                  <span className="from"><b>1 days ago</b> via Mobile, Sydney, Australia</span>
                </div>
                <div className="image"><img src={require('../../assets/images/fundrisescreenshot.png')} alt="img"/>
                </div>
                <Row className='post-actions'>
                <Col sm="4">
                    <a href="#"><Icon name="thumbs-o-up" />Like</a>
                </Col>
                <Col sm="4">
                    <a href="#"><Icon name="comment-o" />Like</a>
                </Col>
                <Col sm="4">
                    <a href="#"><Icon name="share-square-o" />Share</a>
                </Col>
                </Row>
                <ul className="comments">
                  <li>
                    <img src={require('../assets/img/avatars/sunny.png')} alt="img" className="online" />
                    <span className="name">John Doe</span>
                    Nice, I've been looking into investing into real estate without heavily leveraging myself!
                  </li>
                  <li>
                    <img src={require('../assets/img/avatars/2.png')} alt="img" className="online" />
                    <span className="name">Alice Wonder</span>
                    What's the lockup period on this investment?
                  </li>
                  <li>
                    <img src={require('../assets/img/avatars/sunny.png')} alt="img" className="online" />
                    <input type="text" className="form-control" placeholder="Post your comment..." />
                  </li>
                </ul>
              </div>
            </div>

            <div className="panel panel-default">
              <div className="panel-body status">
                <div className="who clearfix">
                  <h4>See anyone you know? Connect with them</h4>
                </div>
                <Row>
                  <div className="text">
                    <Col sm="12" md="6" lg="4">
                      <div className="well text-center connect">
                        <img src={require('../assets/img/avatars/male.png')} alt="img" className="margin-bottom-5 margin-top-5" />
                        <br />
                        <span className="font-xs"><b>Vincent Byscaye</b></span>
                        <br />
                        <a href="#" className="btn btn-xs btn-success margin-top-5 margin-bottom-5"> <span className="font-xs">Connect</span> </a>
                      </div>
                    </Col>
                    <Col sm="12" md="6" lg="4">
                      <div className="well text-center connect">
                        <img src={require('../assets/img/avatars/female.png')} alt="img" className="margin-bottom-5 margin-top-5" />
                        <br />
                        <span className="font-xs"><b>Vincent Byscaye</b></span>
                        <br />
                        <a href="#" className="btn btn-xs btn-success margin-top-5 margin-bottom-5"> <span
                            className="font-xs">Connect</span> </a>
                      </div>
                    </Col>
                    <Col sm="12" md="6" lg="4">
                      <div className="well text-center connect">
                        <img src={require('../assets/img/avatars/female.png')} alt="img" className="margin-bottom-5 margin-top-5" />
                        <br />
                        <span className="font-xs"><b>Vincent Byscaye</b></span>
                        <br />
                        <a href="#" className="btn btn-xs btn-success margin-top-5 margin-bottom-5"> <span
                            className="font-xs">Connect</span> </a>
                      </div>
                    </Col>
                  </div>
                </Row>
                <ul className="links text-right">
                  <li className="">
                    <a href="#">Find people you know <i className="fa fa-arrow-right"></i> </a>
                  </li>
                </ul>
              </div>
            </div>

          </Col>

          <Col xs="12" sm="6" lg="4">

            <div className="panel panel-default">
              <div className="panel-body status">
                <div className="who clearfix">
                  <img src={require('../assets/img/avatars/sunny.png')} alt="img" className="online" />
                  <span className="name"><b>John Doe</b> acquired <strong> $16,680 </strong> of Apple (<strong>AAPL</strong>) stock </span>
                  <span className="from"><b>1 days ago</b> - 120 shares @ $139.00</span>
                </div>
                <div className="text">
                  Beashing on Apple stock (<strong>AAPL</strong>) with iPhone 8 rumors flourishing! Samsung (<strong>SSNLF</strong>) and Microsoft (<strong>MSFT</strong>) exposed. 
                </div>
                <ul className="links">
                  <li>
                    <a href="#"><i className="fa fa-comment"></i> Reply</a>
                  </li>
                  <li>
                    <a href="#"><i className="fa fa-share-square-o"></i> Share</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="panel panel-default">
              <div className="panel-body status smart-form vote">
                <div className="who clearfix">
                  <img src={require('../assets/img/avatars/3.png')} alt="img" className="offline" />
                  <span className="name"><b>Alliz Yaen</b> Shared a deal</span>
                  <span className="from"><b>2 days ago</b> - <a href="http://www.kpp.us.com/">King Penguin</a></span>
                </div>
                <div className="image">
                  <strong>I found an interesting real estate fund manager to invest in and met with the cofounder yesterday. What do you guys think?
                  </strong>
                </div>
                <div className="image"><img src={require('../../assets/images/kingpenguin.svg')} alt="img" />
                </div>
              <div className="image">
                <Row className="comments">
                    <Col xs="12" sm="12" lg="4">
                    
                      <label className="radio questions">
                        <input type="radio" name="radio" />
                        <i></i>Too risky</label>
                    </Col>
                    <Col xs="12" sm="12" lg="4">
                      <label className="radio questions">
                        <input type="radio" name="radio" />
                        <i></i>Sounds interesting. Send me more details.</label>
                    </Col>
                    <Col xs="12" sm="12" lg="4">
                      <label className="radio questions">
                        <input type="radio" name="radio" />
                        <i></i>I'm heavily concentrated in real estate. Looking for other asset classes</label>
                    </Col>
                    <Col xs="12" sm="12" lg="4">
                      <a href="#" className="btn btn-xs btn-primary">Submit</a>
                    </Col>
                </Row>
              </div>
                <ul className="links">
                  <li>
                    <a href="#"><i className="fa fa-thumbs-o-up"></i> Like</a>
                  </li>
                  <li>
                    <a href="#"><i className="fa fa-comment-o"></i> Comment</a>
                  </li>
                  <li>
                    <a href="#"><i className="fa fa-share-square-o"></i> Share</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="panel panel-default">

              <div className="panel-body status">

                <div className="who clearfix">
                  <h4>Latest Forum Posts</h4>
                </div>

                <div className="who clearfix">
                  <img src={require('../assets/img/avatars/2.png')} alt="img" className="busy" />
                  <span className="name font-sm"> <span className="text-muted">Posted by</span> <b> Karrigan Mean <span
                      className="pull-right font-xs text-muted"><i>3 minutes ago</i></span> </b>
                          <br />
                          <a href="#" className="font-md">Business Requirement Docs</a> </span>
                </div>

                <div className="who clearfix">
                  <img src={require('../assets/img/avatars/3.png')} alt="img" className="offline" />
                  <span className="name font-sm"> <span className="text-muted">Posted by</span> <b> Alliz Yaen <span
                      className="pull-right font-xs text-muted"><i>2 days ago</i></span> </b>
                          <br />
                          <a href="#" className="font-md">Maecenas nec odio et ante tincidun</a> </span>
                </div>

                <div className="who clearfix">
                  <img src={require('../assets/img/avatars/4.png')} alt="img" className="away" />
                  <span className="name font-sm"> <span className="text-muted">Posted by</span> <b> Barley Kartzukh <span
                      className="pull-right font-xs text-muted"><i>1 month ago</i></span> </b>
                          <br />
                          <a href="#" className="font-md">Tincidun nec Gasket Mask </a> </span>
                </div>

              </div>

            </div>

          </Col>

          <Col xs="12" sm="6" lg="4">

            <div className="panel panel-default">
              <div className="panel-body status">
                <div className="who clearfix">
                  <img src={require('../assets/img/avatars/sunny.png')} alt="img" className="busy" />
                  <span className="name"><b>You</b> shared a blog</span>
                  <span className="from"><b>1 days ago</b> via Mobile, Sydney, Australia</span>
                </div>
                <div className="text">
                  <p />
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Quisque in mauris elit. Ut nec arcu pretium eros varius porta vitae sit amet ipsum. Suspendisse
                    porttitor, libero in rutrum pretium, lectus arcu maximus massa, ut condimentum metus libero laoreet
                    lectus. Phasellus a lectus pulvinar, lacinia sem quis, suscipit turpis.
                    <br />
                    <br />
                    Nam ipsum orci, blandit in lectus ut, viverra vehicula nisl. Proin eu arcu ut neque tempus viverra nec
                    ac tellus. <strong>[</strong><a href="#">Keep reading</a><strong>]</strong>
                </div>
                <ul className="links">
                  <li>
                    <a href="#"><i className="fa fa-thumbs-o-up"></i> Like</a>
                  </li>
                  <li>
                    <a href="#"><i className="fa fa-comment-o"></i> Comment</a>
                  </li>
                  <li>
                    <a href="#"><i className="fa fa-share-square-o"></i> Share</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="panel panel-default">
              <div className="panel-body status">
                <div className="who clearfix">
                  <h4>Live Twitter Feed</h4>
                </div>
                <div className="text">

                  <blockquote className="twitter-tweet">
                    <p>
                      Sunsets don’t get much better than this one over <a href="https://twitter.com/GrandTetonNPS"
                                                                          target="_blank">@GrandTetonNPS</a>. <a
                        href="https://twitter.com/hashtag/nature?src=hash" target="_blank">#nature</a> <a
                        href="https://twitter.com/hashtag/sunset?src=hash">#sunset</a> <a href="http://t.co/YuKy2rcjyU"
                                                                                          target="_blank">pic.twitter.com/YuKy2rcjyU</a>
                    </p>
                    — US Dept of Interior (@Interior) <a href="https://twitter.com/Interior/status/463440424141459456"
                                                         target="_blank">May 5, 2014</a>
                  </blockquote>

                </div>
                <ul className="links text-right">
                  <li className="">
                    <a href="#">Next <i className="fa fa-arrow-right"></i> </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="panel panel-default">
              <div className="panel-body status">
                <div className="who clearfix">
                  <h4>Live Chat</h4>
                </div>

                <div id="chat-body" className="chat-body custom-scroll">
                  <ul>
                    <li className="message">
                      <img src={require('../assets/img/avatars/5.png')} className="online" alt="" />
                      <div className="message-text">
                        <time>
                          2014-01-13
                        </time>
                        <a href="#" className="username">Sadi Orlaf</a><span> Hey did you meet the new board of
                        director? He's a bit of an arse if you ask me...anyway here is the report you requested. I am off to
                        launch with Lisa and Andrew, you wanna join?</span>
                        <p className="chat-file row">
                          <b className="pull-left col-sm-6"> <i className="fa fa-spinner fa-spin"></i> <i
                              className="fa fa-file"></i> report-2013-demographic-report-annual-earnings.xls </b>
                          <span className="col-sm-6 pull-right"> <a href="#" className="btn btn-xs btn-default">cancel</a> <a
                              href="#" className="btn btn-xs btn-success">save</a> </span>
                        </p>
                      </div>
                    </li>
                    <li className="message">
                      <img src={require('../assets/img/avatars/sunny.png')} className="online" alt="" />
                      <div className="message-text">
                        <time>
                          2014-01-13
                        </time>
                        <a href="#" className="username">John Doe</a> Haha! Yeah I know what you mean. Thanks
                        for the file Sadi! <i className="fa fa-smile-o txt-color-orange"></i>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="chat-footer">
                  <div className="textarea-div">

                    <div className="typearea">
                      <textarea placeholder="Write a reply..." id="textarea-expand" className="custom-scroll"></textarea>
                    </div>

                  </div>
                  <span className="textarea-controls">
                            <button className="btn btn-sm btn-primary pull-right">
                                                        Reply
                                                    </button> <span className="pull-right smart-form smartFormTmp">
                                                    <label className="checkbox pull-right">
                                                    <input type="checkbox" name="subscription" id="subscription" />
                                                    <i></i>Press <strong> ENTER </strong> to send </label> </span> <a
                      href="#" className="pull-left"><i className="fa fa-camera fa-fw fa-lg"></i></a> </span>

                </div>
              </div>
            </div>

          </Col>

        </Row>
      </section>
    </div>
	);
}

}



const modalStyle = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0, 0.3)'
  },
  content: {
    overflow: 'visible',
    position: 'absolute',
    top: '80px',
    left: '25%',
    right: '25%',
    bottom: '40px',
    border: 'none',
    background: 'transparent',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    outline: 'none',
    padding: 'none',
    'max-width': '800px'

  }
};

export { SocialWall };



/** WEBPACK FOOTER **
 ** ./src/common/SocialWall.js
 **/